import * as Form from '../../components/form'
import * as Request from '../../request'
import * as Constants from './constants'
import * as Types from './types'

export const forgotPasswordSubmit: Types.ForgotPasswordSubmit =
  (fields: Types.FormFields) => {
    return Request.requestActionCreator<any>(Constants.FORGOT_PASSWORD)({
      method: 'POST',
      payload: {username: fields.username, forgot_password: true},
      url: '/users/oauth/login/forgot-password',
    })
  }

export const FormActions = Form.createActionsMap(Constants.UPDATE_FORGOT_PASSWORD_FIELD)
export const FormConstants = Form.createConstantsMap(Constants.UPDATE_FORGOT_PASSWORD_FIELD)



// WEBPACK FOOTER //
// ./src/pages/forgot-password/actions.ts